import { createClient } from "merchant-core";

export const { client, setRequestInterceptor, setResponseInterceptor } =
  createClient({
    qpTerritory: process.env.NEXT_PUBLIC_QP_TERRITORY ?? "US",
  });
